/**
 * POST /auth/logout-all - Logout all sessions
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import { deleteCookie } from 'hono/cookie'
import type { AuthService } from '../auth.service.js'
import { getRequestInfo } from './helpers.js'

export const logoutAllAction: ActionDefinition = {
  key: 'logout-all',
  label: { en: 'Logout All Sessions', es: 'Cerrar todas las sesiones' },
  icon: 'mdi:logout-variant',
  scope: 'module',
  group: { en: 'Sessions', es: 'Sesiones' },
  method: 'POST',
  confirm: {
    type: 'simple',
    message: { en: 'This will close all your active sessions on all devices.', es: 'Esto cerrará todas tus sesiones activas en todos los dispositivos.' },
    severity: 'warning'
  },
  middleware: (ctx) => [
    ctx.core.middleware['auth'] as MiddlewareHandler,
    (ctx.services.get('authRateLimits') as { logout: MiddlewareHandler }).logout
  ],
  handler: async (ctx, input, c) => {
    const { _authUserId } = input as { _authUserId?: string }
    if (!_authUserId) throw new ctx.core.errors.UnauthorizedError('Usuario no autenticado')
    const authService = ctx.services.get<AuthService>('auth')
    const sessionsRevoked = await authService.logoutAll(_authUserId, getRequestInfo(c))

    if (c) deleteCookie(c, 'refreshToken', { path: '/api/v1' })

    return { sessionsRevoked }
  }
}
